import React from 'react';

import useCioBrowseAndGqlProducts from '../hooks/useCioBrowseAndGqlProducts';
import useInGridAssets from '../hooks/useInGridAssets';

import DesktopGridDiscoveryGuide from './DesktopGridDiscoveryGuide';
import DesktopGridFilters from './DesktopGridFilters/DesktopGridFilters';
import DesktopGridHeader from './DesktopGridHeader';
import DesktopGridVirtualScroll from './DesktopGridVirtualScroll';
import DesktopSideNav from './DesktopSideNav';

const DesktopGridLayout = () => {
  const {
    products,
    totalNumResults,
    fetchNextPage,
    hasNextPage,
    isCioBrowseFetching,
  } = useCioBrowseAndGqlProducts();

  const { mergedAssetsAndProducts } = useInGridAssets({ products });

  // TODO: handle loading/error states, no results found

  return (
    <div className="max-w-[1504px] mx-auto py-[42px]">
      <div className="max-w-[1330px] mx-auto">
        <DesktopGridDiscoveryGuide />
        <DesktopGridHeader />
        <div className="flex px-[32px] pb-[32px]">
          <div className="flex flex-col w-[268px] mr-[32px]">
            <DesktopSideNav />
            <DesktopGridFilters />
          </div>
          <DesktopGridVirtualScroll
            virtualList={mergedAssetsAndProducts}
            totalNumResults={totalNumResults}
            fetchNextPage={fetchNextPage}
            hasNextPage={hasNextPage}
            isCioBrowseFetching={isCioBrowseFetching}
          />
        </div>
      </div>
    </div>
  );
};

export default DesktopGridLayout;
